import morphism from 'morphism';

import { collectionRequest, collectionResponse, productResponse } from '@hero/schemas';

import { api } from '../api';

import { endpoints } from './endpoints';

export const services = {
  create: formData =>
    api
      .post(endpoints.collections(), morphism(collectionRequest.create, formData))
      .then(res => morphism(collectionResponse.collection, res.data.data)),
  products: async code => {
    return api
      .get(endpoints.products(code))
      .then(res => morphism(productResponse.searchProductSchema, res.data.data));
  },
  list: params =>
    api
      .get(endpoints.collections(), { params })
      .then(res => morphism(collectionResponse.list, res.data.data)),
  detail: id =>
    api
      .get(endpoints.collectionDetail(id))
      .then(res => morphism(collectionResponse.collection, res.data.data)),
  update: (id, params) =>
    api
      .put(endpoints.collectionDetail(id), morphism(collectionRequest.update, params))
      .then(res => res.data.data),
  delete: id => api.delete(endpoints.collectionDetail(id)).then(res => res.data.data)
};
